<div style="padding: 15px;">
  <div class="container-fluid survey-report">
    <div class="row" style="margin-left: 2px;">
      <div class="col">
        <mat-form-field>
          <input matInput [matDatepicker]="startpicker" placeholder="Choose a start date"
            [(ngModel)]="startDate">
            <mat-datepicker-toggle matSuffix [for]="startpicker"></mat-datepicker-toggle>
            <mat-datepicker #startpicker></mat-datepicker>
          </mat-form-field>
        </div>
        <div class="col">
          <mat-form-field>
            <input matInput [matDatepicker]="endpicker" placeholder="Choose a end date" [(ngModel)]="endDate">
            <mat-datepicker-toggle matSuffix [for]="endpicker"></mat-datepicker-toggle>
            <mat-datepicker #endpicker></mat-datepicker>
          </mat-form-field>
        </div>
        <div class="col">
          <button mat-flat-button color="primary" (click)="loadReport(locationId, startDate, endDate)">GO</button>
        </div>
      </div>
      @if (report && report.count >= 5) {
        <div>
          <div class="row margin-left-15">
            <h2>Survey Report for {{report.practiceName}} - {{report.locationName}}</h2>
          </div>
          <div class="row margin-left-15">
            <h5>{{report.startDate | date: 'shortDate'}} to {{report.endDate | date: 'shortDate'}}</h5>
          </div>
          <div class="row margin-left-15" style="color:#2596FF; font-size:28px; font-weight: 600;"> Surveys:
          {{report.count}} </div>
          <div class="row" style="align-items: center;">
            <div class="col-md-12 col-lg-8">
              <div class="row charts">
                @if (chartDataSets) {
                  <div class="col-6">
                    <h4 class="chart-title">Overall</h4>
                    <div style="position: relative">
                      <svg viewBox="0 0 50 50" class="chart-label">
                        <text x="50%" y="1.4em"
                        text-anchor="middle">{{chartDataSets.totalLabel.grade}}</text>
                        <text x="50%" y="3.9em" text-anchor="middle"
                        class="sub-label">{{chartDataSets.totalLabel.percentage}}</text>
                      </svg>
                      @if (chartDataSets.total) {
                        <canvas baseChart style="position: relative"
                          [data]="chartDataSets.total" [labels]="chartLabels" [legend]="false"
                        [options]="chartOptions" chartType="doughnut"></canvas>
                      }
                    </div>
                  </div>
                }
                @if (chartDataSets) {
                  <div class="col-6">
                    <h4 class="chart-title">Pre-Appointment (20)</h4>
                    <div style="position: relative">
                      <svg viewBox="0 0 50 50" class="chart-label">
                        <text x="50%" y="1.4em"
                        text-anchor="middle">{{chartDataSets.preAppointmentLabel.grade}}</text>
                        <text x="50%" y="3.9em" text-anchor="middle"
                        class="sub-label">{{chartDataSets.preAppointmentLabel.percentage}}</text>
                      </svg>
                      @if (chartDataSets.preAppointment) {
                        <canvas baseChart
                          [data]="chartDataSets.preAppointment" [labels]="chartLabelsIndividual"
                          [legend]="false"
                        [options]="chartOptions" chartType="doughnut"></canvas>
                      }
                    </div>
                  </div>
                }
                @if (chartDataSets) {
                  <div class="col-6">
                    <h4 class="chart-title">Arrival (20)</h4>
                    <div style="position: relative">
                      <svg viewBox="0 0 50 50" class="chart-label">
                        <text x="50%" y="1.4em"
                        text-anchor="middle">{{chartDataSets.arrivalLabel.grade}}</text>
                        <text x="50%" y="3.9em" text-anchor="middle"
                        class="sub-label">{{chartDataSets.arrivalLabel.percentage}}</text>
                      </svg>
                      @if (chartDataSets.arrival) {
                        <canvas baseChart [data]="chartDataSets.arrival"
                          [labels]="chartLabelsIndividual" [legend]="false"
                        [options]="chartOptions" chartType="doughnut"></canvas>
                      }
                    </div>
                  </div>
                }
                @if (chartDataSets) {
                  <div class="col-6">
                    <h4 class="chart-title">Appointment (35)</h4>
                    <div style="position: relative">
                      <svg viewBox="0 0 50 50" class="chart-label">
                        <text x="50%" y="1.4em"
                        text-anchor="middle">{{chartDataSets.appointmentLabel.grade}}</text>
                        <text x="50%" y="3.9em" text-anchor="middle"
                        class="sub-label">{{chartDataSets.appointmentLabel.percentage}}</text>
                      </svg>
                      @if (chartDataSets.appointment) {
                        <canvas baseChart [data]="chartDataSets.appointment"
                          [labels]="chartLabelsIndividual" [legend]="false"
                        [options]="chartOptions" chartType="doughnut"></canvas>
                      }
                    </div>
                  </div>
                }
                @if (chartDataSets) {
                  <div class="col-6">
                    <h4 class="chart-title">Referral (30)</h4>
                    <div style="position: relative">
                      <svg viewBox="0 0 50 50" class="chart-label">
                        <text x="50%" y="1.4em"
                        text-anchor="middle">{{chartDataSets.referralLabel.grade}}</text>
                        <text x="50%" y="3.9em" text-anchor="middle"
                        class="sub-label">{{chartDataSets.referralLabel.percentage}}</text>
                      </svg>
                      @if (chartDataSets.referral) {
                        <canvas baseChart [data]="chartDataSets.referral"
                          [labels]="chartLabelsIndividual" [legend]="false"
                        [options]="chartOptions" chartType="doughnut"></canvas>
                      }
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
          <div class="row margin-left-15">
            <div class="out-of-survey-label-section">Out of the surveyed patients they also...</div>
            <div class="container-for-out-of-survey">
              <div class="out-of-survey-label">Sent Nuture/Indoctrination</div>
              <div class="progress progress-survey">
                @if (getOutOfTheSurveyInfoInPercents(report.indoctrinationSent, report.count) > 0) {
                  <div class="progress-bar" role="progressbar" style="height: 100%;"
                    [ngStyle]="{'width': getOutOfTheSurveyInfoInPercents(report.indoctrinationSent, report.count)+'%'}">
                  {{getOutOfTheSurveyInfoInPercentsValue(report.indoctrinationSent, report.count)}}% </div>
                }
                @if (getOutOfTheSurveyInfoInPercents(report.indoctrinationSent, report.count) == 0) {
                  <div
                  class="zero-percent">0%</div>
                }
              </div>
              <div class="out-of-survey-label">Completed Forms</div>
              <div class="progress progress-survey">
                @if (getOutOfTheSurveyInfoInPercents(report.completedForms, report.count) > 0) {
                  <div class="progress-bar" role="progressbar" style="height: 100%;"
                    [ngStyle]="{'width': getOutOfTheSurveyInfoInPercents(report.completedForms, report.count)+'%'}">
                  {{getOutOfTheSurveyInfoInPercentsValue(report.completedForms, report.count)}}% </div>
                }
                @if (getOutOfTheSurveyInfoInPercents(report.completedForms, report.count) == 0) {
                  <div
                  class="zero-percent"> 0%</div>
                }
              </div>
              <div class="out-of-survey-label">Had Insurance</div>
              <div class="progress progress-survey">
                @if (getOutOfTheSurveyInfoInPercents(report.hadInsurance, report.count) > 0) {
                  <div class="progress-bar" role="progressbar" style="height: 100%;"
                    [ngStyle]="{'width': getOutOfTheSurveyInfoInPercents(report.hadInsurance, report.count)+'%'}">
                  {{getOutOfTheSurveyInfoInPercentsValue(report.hadInsurance, report.count)}}% </div>
                }
                @if (getOutOfTheSurveyInfoInPercents(report.hadInsurance, report.count) == 0) {
                  <div
                  class="zero-percent">0% </div>
                }
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col" style="margin-left: 15px;">
              <mat-list role="list" class="survey-list">
                <div style="width: 35vw;">
                  <h2 mat-subheader class="survey-label" style="margin-top: 15px;">What could we have done to
                    improve your
                  experience with {{report.practiceName}} prior to your appointment?</h2>
                  <div class="container-for-survey-list">
                    @for (comment of report.comments.preAppointment; track comment) {
                      <mat-list-item role="listitem" class="survey-list-item"
                      >- {{comment}}</mat-list-item>
                    }
                  </div>
                  <h2 mat-subheader class="survey-label" style="margin-top: 15px;">What could we have done to
                    improve your
                  experience upon arrival for your appointment?</h2>
                  <div class="container-for-survey-list">
                    @for (comment of report.comments.arrival; track comment) {
                      <mat-list-item role="listitem" class="survey-list-item"
                      > - {{comment}}</mat-list-item>
                    }
                  </div>
                </div>
                <div style="width: 35vw; margin-left: 12px;">
                  <h2 mat-subheader class="survey-label" style="margin-top: 15px;">What could we have done to
                    improve your
                    experience during the
                  appointment?</h2>
                  <div class="container-for-survey-list">
                    @for (comment of report.comments.appointment; track comment) {
                      <mat-list-item role="listitem" class="survey-list-item"
                      >- {{comment}}</mat-list-item>
                    }
                  </div>
                  <h2 mat-subheader class="survey-label" style="margin-top: 15px;">What can we do to make your
                    experience
                  even better?</h2>
                  <div class="container-for-survey-list">
                    @for (comment of report.comments.referral; track comment) {
                      <mat-list-item role="listitem" class="survey-list-item"
                      >- {{comment}}</mat-list-item>
                    }
                  </div>
                </div>
              </mat-list>
            </div>
          </div>
          <div class="row" id="survey-dropdowns">
            <div class="col" style="margin-top: 10px">
              <mat-expansion-panel>
                <mat-expansion-panel-header>
                  <div class="breakdown-section-label">Pre-Appointment Breakdown</div>
                </mat-expansion-panel-header>
                <div class="container-for-survey-list container-for-survey-list-breakdown">
                  @for (paQuestionWithAnswers of report.paQuestionsWithAnswers; track paQuestionWithAnswers) {
                    <div
                      class="survey-questions">
                      <h2 class="survey-list-item">{{paQuestionWithAnswers.question}}</h2>
                      @if (paQuestionWithAnswers.questionType == 4) {
                        <div class="progress">
                          @if (getOutOfTheSurveyInfoInPercents(paQuestionWithAnswers.numericAnswers[1], report.count) != 0) {
                            <div class="progress-bar progress-min-width-40"
                              style="background-color: rgba(37, 150, 255, 0.15)" role="progressbar"
                              [ngStyle]="{'width': getOutOfTheSurveyInfoInPercents(paQuestionWithAnswers.numericAnswers[1], report.count)+'%'}">
                            1 ({{paQuestionWithAnswers.numericAnswers[1]}})</div>
                          }
                          @if (getOutOfTheSurveyInfoInPercents(paQuestionWithAnswers.numericAnswers[2], report.count) != 0) {
                            <div class="progress-bar progress-min-width-40"
                              style="background-color: rgba(37, 150, 255, 0.20)" role="progressbar"
                              [ngStyle]="{'width': getOutOfTheSurveyInfoInPercents(paQuestionWithAnswers.numericAnswers[2], report.count)+'%'}">
                            2 ({{paQuestionWithAnswers.numericAnswers[2]}})</div>
                          }
                          @if (getOutOfTheSurveyInfoInPercents(paQuestionWithAnswers.numericAnswers[3], report.count) != 0) {
                            <div class="progress-bar progress-min-width-40"
                              style="background-color: rgba(37, 150, 255, 0.25)" role="progressbar"
                              [ngStyle]="{'width': getOutOfTheSurveyInfoInPercents(paQuestionWithAnswers.numericAnswers[3], report.count)+'%'}">
                            3 ({{paQuestionWithAnswers.numericAnswers[3]}})</div>
                          }
                          @if (getOutOfTheSurveyInfoInPercents(paQuestionWithAnswers.numericAnswers[4], report.count) != 0) {
                            <div class="progress-bar progress-min-width-40"
                              style="background-color: rgba(37, 150, 255, 0.30)" role="progressbar"
                              [ngStyle]="{'width': getOutOfTheSurveyInfoInPercents(paQuestionWithAnswers.numericAnswers[4], report.count)+'%'}">
                            4 ({{paQuestionWithAnswers.numericAnswers[4]}})</div>
                          }
                          @if (getOutOfTheSurveyInfoInPercents(paQuestionWithAnswers.numericAnswers[5], report.count) != 0) {
                            <div class="progress-bar progress-min-width-40"
                              style="background-color: rgba(37, 150, 255, 0.45)" role="progressbar"
                              [ngStyle]="{'width': getOutOfTheSurveyInfoInPercents(paQuestionWithAnswers.numericAnswers[5], report.count)+'%'}">
                            5 ({{paQuestionWithAnswers.numericAnswers[5]}})</div>
                          }
                        </div>
                      }
                      @if (paQuestionWithAnswers.questionType == 2) {
                        <div class="progress">
                          @if (getOutOfTheSurveyInfoInPercents(paQuestionWithAnswers.booleanAnswers[false], report.count) != 0) {
                            <div class="progress-bar progress-min-width-40"
                              style="background-color: rgba(37, 150, 255, 0.25)" role="progressbar"
                              [ngStyle]="{'width': getOutOfTheSurveyInfoInPercents(paQuestionWithAnswers.booleanAnswers[false], report.count)+'%'}">
                            No ({{paQuestionWithAnswers.booleanAnswers[false]}})</div>
                          }
                          @if (getOutOfTheSurveyInfoInPercents(paQuestionWithAnswers.booleanAnswers[true], report.count) != 0) {
                            <div class="progress-bar progress-min-width-40"
                              style="background-color: rgba(37, 150, 255, 0.45)" role="progressbar"
                              [ngStyle]="{'width': getOutOfTheSurveyInfoInPercents(paQuestionWithAnswers.booleanAnswers[true], report.count)+'%'}">
                            Yes ({{paQuestionWithAnswers.booleanAnswers[true]}})</div>
                          }
                        </div>
                      }
                    </div>
                  }
                </div>
              </mat-expansion-panel>
              <mat-expansion-panel>
                <mat-expansion-panel-header>
                  <div class="breakdown-section-label">Arrival Breakdown</div>
                </mat-expansion-panel-header>
                <div class="container-for-survey-list container-for-survey-list-breakdown">
                  @for (arQuestionWithAnswers of report.arQuestionsWithAnswers; track arQuestionWithAnswers) {
                    <div
                      class="survey-questions">
                      <h2 class="survey-list-item">{{arQuestionWithAnswers.question}}</h2>
                      @if (arQuestionWithAnswers.questionType == 4) {
                        <div class="progress">
                          @if (getOutOfTheSurveyInfoInPercents(arQuestionWithAnswers.numericAnswers[1], report.count) != 0) {
                            <div class="progress-bar progress-min-width-40"
                              style="background-color: rgba(37, 150, 255, 0.15)" role="progressbar"
                              [ngStyle]="{'width': getOutOfTheSurveyInfoInPercents(arQuestionWithAnswers.numericAnswers[1], report.count)+'%'}">
                            1 ({{arQuestionWithAnswers.numericAnswers[1]}})</div>
                          }
                          @if (getOutOfTheSurveyInfoInPercents(arQuestionWithAnswers.numericAnswers[2], report.count) != 0) {
                            <div class="progress-bar progress-min-width-40"
                              style="background-color: rgba(37, 150, 255, 0.20)" role="progressbar"
                              [ngStyle]="{'width': getOutOfTheSurveyInfoInPercents(arQuestionWithAnswers.numericAnswers[2], report.count)+'%'}">
                            2 ({{arQuestionWithAnswers.numericAnswers[2]}})</div>
                          }
                          @if (getOutOfTheSurveyInfoInPercents(arQuestionWithAnswers.numericAnswers[3], report.count) != 0) {
                            <div class="progress-bar progress-min-width-40"
                              style="background-color: rgba(37, 150, 255, 0.25)" role="progressbar"
                              [ngStyle]="{'width': getOutOfTheSurveyInfoInPercents(arQuestionWithAnswers.numericAnswers[3], report.count)+'%'}">
                            3 ({{arQuestionWithAnswers.numericAnswers[3]}})</div>
                          }
                          @if (getOutOfTheSurveyInfoInPercents(arQuestionWithAnswers.numericAnswers[4], report.count) != 0) {
                            <div class="progress-bar progress-min-width-40"
                              style="background-color: rgba(37, 150, 255, 0.30)" role="progressbar"
                              [ngStyle]="{'width': getOutOfTheSurveyInfoInPercents(arQuestionWithAnswers.numericAnswers[4], report.count)+'%'}">
                            4 ({{arQuestionWithAnswers.numericAnswers[4]}})</div>
                          }
                          @if (getOutOfTheSurveyInfoInPercents(arQuestionWithAnswers.numericAnswers[5], report.count) != 0) {
                            <div class="progress-bar progress-min-width-40"
                              style="background-color: rgba(37, 150, 255, 0.45)" role="progressbar"
                              [ngStyle]="{'width': getOutOfTheSurveyInfoInPercents(arQuestionWithAnswers.numericAnswers[5], report.count)+'%'}">
                            5 ({{arQuestionWithAnswers.numericAnswers[5]}})</div>
                          }
                        </div>
                      }
                      @if (arQuestionWithAnswers.questionType == 2) {
                        <div class="progress">
                          @if (getOutOfTheSurveyInfoInPercents(arQuestionWithAnswers.booleanAnswers[false], report.count) != 0) {
                            <div class="progress-bar progress-min-width-40"
                              style="background-color: rgba(37, 150, 255, 0.25)" role="progressbar"
                              [ngStyle]="{'width': getOutOfTheSurveyInfoInPercents(arQuestionWithAnswers.booleanAnswers[false], report.count)+'%'}">
                            No ({{arQuestionWithAnswers.booleanAnswers[false]}})</div>
                          }
                          @if (getOutOfTheSurveyInfoInPercents(arQuestionWithAnswers.booleanAnswers[true], report.count) != 0) {
                            <div class="progress-bar progress-min-width-40"
                              style="background-color: rgba(37, 150, 255, 0.45)" role="progressbar"
                              [ngStyle]="{'width': getOutOfTheSurveyInfoInPercents(arQuestionWithAnswers.booleanAnswers[true], report.count)+'%'}">
                            Yes ({{arQuestionWithAnswers.booleanAnswers[true]}})</div>
                          }
                        </div>
                      }
                    </div>
                  }
                </div>
              </mat-expansion-panel>
              <mat-expansion-panel>
                <mat-expansion-panel-header>
                  <div class="breakdown-section-label">Appointment Breakdown</div>
                </mat-expansion-panel-header>
                <div class="container-for-survey-list container-for-survey-list-breakdown">
                  <div>
                    @for (apQuestionWithAnswers of report.apQuestionsWithAnswers; track apQuestionWithAnswers) {
                      <div
                        class="survey-questions">
                        <h2 class="survey-list-item">{{apQuestionWithAnswers.question}}</h2>
                        <div class="progress">
                          @if (getOutOfTheSurveyInfoInPercents(apQuestionWithAnswers.numericAnswers[1], report.count) != 0) {
                            <div class="progress-bar progress-min-width-40"
                              style="background-color: rgba(37, 150, 255, 0.15)" role="progressbar"
                              [ngStyle]="{'width': getOutOfTheSurveyInfoInPercents(apQuestionWithAnswers.numericAnswers[1], report.count)+'%'}">
                            1 ({{apQuestionWithAnswers.numericAnswers[1]}})</div>
                          }
                          @if (getOutOfTheSurveyInfoInPercents(apQuestionWithAnswers.numericAnswers[2], report.count) != 0) {
                            <div class="progress-bar progress-min-width-40"
                              style="background-color: rgba(37, 150, 255, 0.20)" role="progressbar"
                              [ngStyle]="{'width': getOutOfTheSurveyInfoInPercents(apQuestionWithAnswers.numericAnswers[2], report.count)+'%'}">
                            2 ({{apQuestionWithAnswers.numericAnswers[2]}})</div>
                          }
                          @if (getOutOfTheSurveyInfoInPercents(apQuestionWithAnswers.numericAnswers[3], report.count) != 0) {
                            <div class="progress-bar progress-min-width-40"
                              style="background-color: rgba(37, 150, 255, 0.25)" role="progressbar"
                              [ngStyle]="{'width': getOutOfTheSurveyInfoInPercents(apQuestionWithAnswers.numericAnswers[3], report.count)+'%'}">
                            3 ({{apQuestionWithAnswers.numericAnswers[3]}})</div>
                          }
                          @if (getOutOfTheSurveyInfoInPercents(apQuestionWithAnswers.numericAnswers[4], report.count) != 0) {
                            <div class="progress-bar progress-min-width-40"
                              style="background-color: rgba(37, 150, 255, 0.30)" role="progressbar"
                              [ngStyle]="{'width': getOutOfTheSurveyInfoInPercents(apQuestionWithAnswers.numericAnswers[4], report.count)+'%'}">
                            4 ({{apQuestionWithAnswers.numericAnswers[4]}})</div>
                          }
                          @if (getOutOfTheSurveyInfoInPercents(apQuestionWithAnswers.numericAnswers[5], report.count) != 0) {
                            <div class="progress-bar progress-min-width-40"
                              style="background-color: rgba(37, 150, 255, 0.45)" role="progressbar"
                              [ngStyle]="{'width': getOutOfTheSurveyInfoInPercents(apQuestionWithAnswers.numericAnswers[5], report.count)+'%'}">
                            5 ({{apQuestionWithAnswers.numericAnswers[5]}})</div>
                          }
                        </div>
                      </div>
                    }
                  </div>
                </div>
              </mat-expansion-panel>
              <mat-expansion-panel>
                <mat-expansion-panel-header>
                  <div class="breakdown-section-label">Referral Breakdown</div>
                </mat-expansion-panel-header>
                <div class="container-for-survey-list container-for-survey-list-breakdown">
                  <div>
                    @for (reQuestionWithAnswers of report.reQuestionsWithAnswers; track reQuestionWithAnswers) {
                      <div
                        class="survey-questions">
                        <h2 class="survey-list-item">{{reQuestionWithAnswers.question}}</h2>
                        <div class="progress">
                          @if (getOutOfTheSurveyInfoInPercents(reQuestionWithAnswers.numericAnswers[1], report.count) != 0) {
                            <div class="progress-bar progress-min-width-40"
                              style="background-color: rgba(37, 150, 255, 0.15)" role="progressbar"
                              [ngStyle]="{'width': getOutOfTheSurveyInfoInPercents(reQuestionWithAnswers.numericAnswers[1], report.count)+'%'}">
                            1 ({{reQuestionWithAnswers.numericAnswers[1]}})</div>
                          }
                          @if (getOutOfTheSurveyInfoInPercents(reQuestionWithAnswers.numericAnswers[2], report.count) != 0) {
                            <div class="progress-bar progress-min-width-40"
                              style="background-color: rgba(37, 150, 255, 0.20)" role="progressbar"
                              [ngStyle]="{'width': getOutOfTheSurveyInfoInPercents(reQuestionWithAnswers.numericAnswers[2], report.count)+'%'}">
                            2 ({{reQuestionWithAnswers.numericAnswers[2]}})</div>
                          }
                          @if (getOutOfTheSurveyInfoInPercents(reQuestionWithAnswers.numericAnswers[3], report.count) != 0) {
                            <div class="progress-bar progress-min-width-40"
                              style="background-color: rgba(37, 150, 255, 0.25)" role="progressbar"
                              [ngStyle]="{'width': getOutOfTheSurveyInfoInPercents(reQuestionWithAnswers.numericAnswers[3], report.count)+'%'}">
                            3 ({{reQuestionWithAnswers.numericAnswers[3]}})</div>
                          }
                          @if (getOutOfTheSurveyInfoInPercents(reQuestionWithAnswers.numericAnswers[4], report.count) != 0) {
                            <div class="progress-bar progress-min-width-40"
                              style="background-color: rgba(37, 150, 255, 0.30)" role="progressbar"
                              [ngStyle]="{'width': getOutOfTheSurveyInfoInPercents(reQuestionWithAnswers.numericAnswers[4], report.count)+'%'}">
                            4 ({{reQuestionWithAnswers.numericAnswers[4]}})</div>
                          }
                          @if (getOutOfTheSurveyInfoInPercents(reQuestionWithAnswers.numericAnswers[5], report.count) != 0) {
                            <div class="progress-bar progress-min-width-40"
                              style="background-color: rgba(37, 150, 255, 0.45)" role="progressbar"
                              [ngStyle]="{'width': getOutOfTheSurveyInfoInPercents(reQuestionWithAnswers.numericAnswers[5], report.count)+'%'}">
                            5 ({{reQuestionWithAnswers.numericAnswers[5]}})</div>
                          }
                        </div>
                      </div>
                    }
                  </div>
                </div>
              </mat-expansion-panel>
            </div>
          </div>
        </div>
      }
      @if (report && report.count == 0) {
        <div class="row">
          <div class="col">
            <h1>No surveys found</h1>
          </div>
        </div>
      }
      @if (report && report.count != 0 && report.count < 5) {
        <div class="row">
          <div class="col">
            <h1>There are less than 5 surveys</h1>
          </div>
        </div>
      }
    </div>
  </div>
